import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';

function JsonErrorModal(props) {
    const { errorModal, errorMessage} = props;
    const { t } = useTranslation();

    const errorModalHandler = () => {
        props.handleErrorModal(false);
    }

    return (
        <>
            <Dialog
                open={errorModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className='dialog-header'>
                    <div className="title">{t('ERROR')}</div>
                </DialogTitle>

                <DialogContent className='modal-content' dividers>{errorMessage}</DialogContent>

                <DialogActions>
                    <Button
                        size="small"
                        onClick={errorModalHandler}
                        variant={"outlined"}
                    >
                        {t("BTN_OK")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default JsonErrorModal